// Polis dans la nouvelle interface : la page, l'élection, le dialogue « Nouvelle élection » (10 octobre 2026).
export default {
  onglets: {
    projection: 'Projections',
    candidats: 'Candidats',
    electorat: 'Électorat',
    scenarios: 'Scénarios',
    sonar: 'Sonar',
    registre: 'Registre',
    scrutin: 'Réglages de l’élection',
  },
  dans: 'dans {n} jours',
  demain: 'demain',
  aujourdhui: 'aujourd’hui',
  chargement: 'Les élections se lisent…',
  erreur: 'Les élections n’ont pas pu se lire.',
  fermer: 'Fermer',
  aucune: {
    titre: 'Aucune élection pour l’instant',
    texte: 'Une élection se crée en quelques champs : Orion se renseigne ensuite sur ses règles, son calendrier, ses candidats et sa campagne, puis prépare l’électorat.',
    creer: 'Nouvelle élection',
  },
  preparation: {
    titre: 'Orion prépare cette élection',
    texte: 'Il lit les règles, le calendrier, les listes ou les candidats, leurs fiches et l’état de la campagne. La page se met à jour seule.',
  },
  echec: {
    titre: 'Orion n’a pas pu préparer cette élection',
    inconnue: 'La raison n’est pas connue.',
  },
  nouvelle: {
    titre: 'Nouvelle élection',
    chapeau: 'Orion lit les règles, le calendrier, les candidats et la campagne, puis prépare l’électorat. Comptez quelques minutes.',
    pays: 'Pays',
    jour: 'Jour du vote',
    scrutin: 'Le scrutin',
    types: {
      proportionnel: { titre: 'À la proportionnelle', texte: 'Des sièges, un seuil, des blocs et une majorité : la Knesset, des législatives à la proportionnelle.' },
      'deux-tours': { titre: 'À deux tours', texte: 'Un premier tour en pourcentages et deux qualifiés : une présidentielle.' },
      majoritaire: { titre: 'À un tour', texte: 'Un seul tour, le premier l’emporte : une course au Sénat américain, un second tour.' },
    },
    nom: 'Nom de l’élection',
    nomExemple: 'Élection présidentielle',
    consignes: 'Ce que vous voulez projeter',
    consignesExemple: 'Tous les candidats déclarés ; ou une hypothèse : tel candidat se présente, tel autre non',
    sondages: 'Les jumeaux ne liront jamais de sondage : Orion s’en sert seulement pour caler la projection.',
    annuler: 'Annuler',
    creer: 'Orion se renseigne',
    erreur: 'L’élection n’a pas pu être créée.',
  },
}
